import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import CheckBox from 'components/CheckBox';
import DatasetColumnLabel from 'components/DatasetColumnLabel';

import ParameterFilter from './ParameterFilter';
import ParameterFiltersModal from './ParameterFiltersModal';
import FilterTrigger from './ParameterFiltersModal/Triggers';

import { toggleSelectedParameterVisibility } from 'store/dataset';

const SelectedParameterComponent = props => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const onVisibilityCheckboxChange = () => {
    dispatch(toggleSelectedParameterVisibility(props.name));
  };

  return (
    <div className="mb-25">
      <div className="mb-15">
        <div className="main-checkbox-filter mb-5" data-testid="chosenRowDataSet">
          <CheckBox
            checked={props.isVisible}
            onChange={onVisibilityCheckboxChange}
          >

            {props.name}
          </CheckBox>

          <DatasetColumnLabel
            type={props.targetType}
            containerClassName="flex flex-shrink"
            iconContainerClassName="ml-10"
          >

            <ParameterFiltersModal
              parameterName={props.name}
              isOpen={isOpen}
              onCloseModal={closeModal}
            />
          </DatasetColumnLabel>
          <FilterTrigger openModal={openModal} />
        </div>

        {props.filterType &&
          <ParameterFilter
            name={props.name}
            filterType={props.filterType}
            filterOptions={props.filterOptions}
          />
        }
      </div>
    </div>
  );
};

SelectedParameterComponent.propTypes = {
  name: PropTypes.string.isRequired,
  targetType: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,

  filterType: PropTypes.string,
  filterOptions: PropTypes.object
};

SelectedParameterComponent.defaultProps = {
  filterOptions: null,
  filterType: null
};

export default SelectedParameterComponent;
